/* ---------- CP-001's earthing busbar -PE to -WE1 (#1907, row 17; engineer 3, 6186890646) ----------
 * IEC 81346-2 gives the earthing busbar the class WE, so the bar's tag "PE" is "WE1", as CP-002's. A save made with the old tag names it
 * as a device ({ tag: "PE" }) and in every terminal reference on it ("PE:5"), in its drawings, its wires and its commissioning
 * readings. The protective conductor's number "PE", a conductor's mark (IEC 60445), and the terminals "XD0:PE", "U1:PE", "MA1:PE" stay:
 * they are not the bar. The save migration in packages/progress uses this (format 16); nothing else does. Self-contained on purpose:
 * the migration imports this file alone, not CP-001's model. */

/** The bar's old tag and its new one (without the leading dash). */
export const CP001_BAR_RENAME = { from: "PE", to: "WE1" } as const;

/** A terminal on the bar, wherever it stands as a whole terminal: "PE:5", or inside a key ("PE:1|U1:PE"); never "XD0:PE". */
const ON_BAR = /(?<![\w:-])PE(?=:\d)/g;
const renamed = (s: string) => s.replace(ON_BAR, CP001_BAR_RENAME.to);

function walk(v: any, key?: string): any {
  if (typeof v === "string") return key === "tag" && v === CP001_BAR_RENAME.from ? CP001_BAR_RENAME.to : renamed(v);
  if (Array.isArray(v)) return v.map(x => walk(x));
  if (v && typeof v === "object") return Object.fromEntries(Object.entries(v).map(([k, x]) => [renamed(k), walk(x, k)]));
  return v;
}

const one = <A extends { model?: any; ui?: any }>(s: A): A => {
  const asText = typeof s.model === "string", model = walk(asText ? JSON.parse(s.model) : s.model ?? null);
  return { ...s, model: asText ? JSON.stringify(model, null, 2) : model, ui: walk(s.ui ?? {}) };
};
/** A saved CP-001 project ({ model, ui }, the model as a JSON string or an object, as saved) with the bar's new tag: its own work and
 *  each earlier attempt it keeps ("Start again", #1220). */
export function renameCp001Bar<T extends { model?: any; ui?: any; attempts?: any[] }>(s: T): T {
  const out = one(s);
  return Array.isArray(s.attempts) ? { ...out, attempts: s.attempts.map(a => one(a)) } : out;
}
